export const GROUP = {
  DIFFERENCES: {
    id: "Diferencias",
    title: "Diferenciais"
  },
  SERVICE: {
    id: "Atendimento",
    title: "Atendimento"
  },
  PRODUCT_CATEGORIES: {
    id: "Categorias_de_Produtos",
    title: "Categoria de produtos"
  },
  SERVICES: {
    id: "Servicos",
    title: "Serviços Pet Anjo",
    label: "Serviços oferecidos por profissionais parceiros:"
  }
};
